import { size } from 'lodash';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { emitter } from '../../../utils/emitter';
import _ from 'lodash'; // thu vien giup cac hang viet ngan gon hon
class ModalEditCountry extends Component {

    constructor(props) {
        super(props);
        this.state = {
            countryName: '',
            countryFlag: '',
            countryShortName: '',
            countryCurrency: '',
        }

    }

    componentDidMount() {
        // console.log('Did mount edit Country: ', this.props.currentCountry)
        let country = this.props.currentCountry;
        if (country && !_.isEmpty(country)) {
            this.setState({
                countryName: country.countryName,
                countryFlag: country.countryFlag,
                countryShortName: country.countryShortName,
                countryCurrency: country.countryCurrency,
                id: country.id
            })
        }
    }
    toggle = () => {
        this.props.tooglefromParent()
    }
    handleOnchangeInput = (event, id) => {
        // bad code this.state[id] = event.target.value , ko nen update truc tiep
        // good code, thong qua 1 bien trung gian
        let copyState = { ...this.state }; // copy state moi
        copyState[id] = event.target.value
        this.setState({
            ...copyState
        }, () => { // callback function

        })
        // console.log("copyState: ", copyState)
        // console.log(event.target.value, id)
    }
    checkValideInput = () => {
        let arrInput = ['countryName', 'countryFlag', 'countryShortName', 'countryCurrency'];
        let isValide = true;
        for (let i = 0; i < arrInput.length; i++) { // neu dung vong lap MAP thi ko the dung break, foreach

            if (!this.state[arrInput[i]]) {
                isValide = false
                alert("Missing parameters" + arrInput[i]);
                break;
            }
        }
        return isValide
    }
    handleEditCountry = () => {
        let isValide = this.checkValideInput();
        if (isValide == true) {
            this.props.editCurrentCountry(this.state)
        }


        // console.log("data modal edit Country: ", this.state)
    }

    render() {
        // console.log('check child props:', this.props);
        // console.log('check child open modal:', this.props.currentCountry);
        return (
            <Modal
                isOpen={this.props.isOpen}
                toggle={this.toggle}
                className="modal-country-container"
                size="lg"
                centered
            >
                <ModalHeader toggle={this.toggle}>Edit Country</ModalHeader>
                <ModalBody>
                    <div className='modal-country-body'>

                        <div className='input-container'>
                            <label>Country Name: </label>
                            <input
                                type="text"
                                name="countryName"
                                // placeholder="Enter email"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'countryName')
                                }}
                                value={this.state.countryName}

                            />
                        </div>
                        <div className='input-container'>
                            <label>Flag: </label>
                            <input
                                type="text"
                                name="countryFlag"
                                placeholder="Enter Flag"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'countryFlag')
                                }}
                                value={this.state.countryFlag}
                            />
                        </div>
                    </div>
                    <div className='modal-country-body'>
                        <div className='input-container'>
                            <label>Short Name: </label>
                            <input
                                type="text"
                                name="countryShortName"
                                placeholder="Enter fullname"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'countryShortName')
                                }}
                                value={this.state.countryShortName}
                            />
                        </div>
                        <div className='input-container'>
                            <label>Currency: </label>
                            <input
                                type="text"
                                name="countryCurrency"
                                placeholder="Enter currency"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'countryCurrency')
                                }}
                                value={this.state.countryCurrency}

                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button className='px-2' color="primary" onClick={this.handleEditCountry}>Save</Button>{' '}
                    <Button className='px-2' color="secondary" onClick={this.toggle}>Close</Button>
                </ModalFooter>
            </Modal>
        )
    }

}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditCountry);


